import { getMyEmployerPayrollTaxSavingsChartData } from "../../../../api/dossier/getMyEmployerPayrollTaxSavingsChartData";
import { PayrollTaxSavingsChartDatum } from "../../../../types/Chart";
import APChart from "../APChart";

type EmployerPayrollTaxSavingsChartProps = {
  customHeight?: number;
};

const EmployerPayrollTaxSavingsChart = ({
  customHeight,
}: EmployerPayrollTaxSavingsChartProps) => {
  return (
    <APChart
      type="line"
      chartTitle="Lifetime Payroll Tax Savings^"
      getData={() =>
        getMyEmployerPayrollTaxSavingsChartData<PayrollTaxSavingsChartDatum>()
      }
      xAxisOptions={{ type: "time" }}
      yAxisOptions={{ type: "currency" }}
      dimensions={[
        { key: "date", label: "Date" },
        { key: "payrollTaxSavings", label: "Savings" },
      ]}
      isAreaChart={true}
      customHeight={customHeight}
    />
  );
};

export default EmployerPayrollTaxSavingsChart;
